// extracted by mini-css-extract-plugin
export default {"flex-row":"App_flex-row__xrFsE","flex-column":"App_flex-column__qpqJL","app":"App_app__GuJBs","container":"App_container__4L7Vo"};